module.exports = __webpack_public_path__ + "img/icon_mail_forwarding.7ddfd80c.svg";